import React from "react";
import dayjs from "dayjs";
import ListDropdown from "./ListDropdown";
import capitalize from "../../../Utils/capitalize";

export const BE_RATE_OPERATION_TYPE = {
  TRIP: 1,
  RENTAL: 2,
  SESSION: 3,
};

export const BE_RATE_BATTERY_TYPE = {
  "Kawi 1.6.0-DA-AN": 3,
  "Kawi 1.6.1-JK-CH": 4,
  "Kawi 3.7.0-DA-AN": 5,
  "Kawi 3.7.1-JK-AN": 6,
  "Kawi 3.7.2-JK-CH": 7,
  "Kawi 3.7.3-JK-CH": 8,
  "Kawi 15.0-JK-CH": 9,
};

export const columns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Battery Type
      </div>
    ),
    dataIndex: "batteryTypeName",
    sorter: (a, b) => a.batteryTypeName.localeCompare(b.batteryTypeName),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 py-1 capitalize">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Hub Station
      </div>
    ),
    dataIndex: "hubName",
    sorter: (a, b) => a.hubName.localeCompare(b.hubName),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Operation Type
      </div>
    ),
    dataIndex: "operationTypeName",
    sorter: (a, b) => a.operationTypeName.localeCompare(b.operationTypeName),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Unit of Measurement
      </div>
    ),
    dataIndex: "unit",
    // sorter: (a, b) => a.unit.localeCompare(b.unit),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
        {capitalize(text[0])}
        {text.substring(1)}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Energy Rate
      </div>
    ),
    dataIndex: "rate",
    sorter: (a, b) => a.rate - b.rate,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
        {text} KSH
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Last Modified
      </div>
    ),
    dataIndex: "updatedAt",
    sorter: (a, b) => a?.updatedAt?.localeCompare(b?.updatedAt),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
        {dayjs(text).format("DD-MM-YYYY, hh:mm a")}
      </div>
    ),
  },
  {
    dataIndex: "id",
    width: "5%",
    render: (text, record) => (
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
        }}
        className="invisible group-hover:visible w-full flex items-center justify-center"
      >
        <ListDropdown detail={record} />
      </button>
    ),
  },
];

export const batteryTypeFilters = [
  {
    id: BE_RATE_BATTERY_TYPE["Kawi 1.6.0-DA-AN"],
    value: "Kawi 1.6.0-DA-AN",
  },
  {
    id: BE_RATE_BATTERY_TYPE["Kawi 1.6.1-JK-CH"],
    value: "Kawi 1.6.1-JK-CH",
  },
  {
    id: BE_RATE_BATTERY_TYPE["Kawi 3.7.0-DA-AN"],
    value: "Kawi 3.7.0-DA-AN",
  },
  {
    id: BE_RATE_BATTERY_TYPE["Kawi 3.7.1-JK-AN"],
    value: "Kawi 3.7.1-JK-AN",
  },
  {
    id: BE_RATE_BATTERY_TYPE["Kawi 3.7.2-JK-CH"],
    value: "Kawi 3.7.2-JK-CH",
  },
  {
    id: BE_RATE_BATTERY_TYPE["Kawi 3.7.3-JK-CH"],
    value: "Kawi 3.7.3-JK-CH",
  },
  {
    id: BE_RATE_BATTERY_TYPE["Kawi 15.0-JK-CH"],
    value: "Kawi 15.0-JK-CH",
  },
];

export const operationTypeFilters = [
  {
    id: BE_RATE_OPERATION_TYPE.TRIP,
    value: "Trip",
  },
  {
    id: BE_RATE_OPERATION_TYPE.RENTAL,
    value: "Rental",
  },
  {
    id: BE_RATE_OPERATION_TYPE.SESSION,
    value: "Session",
  },
];
